import { dropUndefinedKeys } from '@sentry/utils';
import { DEFAULT_ENVIRONMENT } from '../constants.js';
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatchs the `createDsc` lifecycle hook as a side effect.
 */

function getDynamicSamplingContextFromClient(trace_id, client, scope) {
  var options = client.getOptions();

  var _ref = client.getDsn() || {},
      public_key = _ref.publicKey;

  var _ref2 = scope && scope.getUser() || {},
      user_segment = _ref2.segment;

  var dsc = dropUndefinedKeys({
    environment: options.environment || DEFAULT_ENVIRONMENT,
    release: options.release,
    user_segment: user_segment,
    public_key: public_key,
    trace_id: trace_id
  });
  client.emit && client.emit('createDsc', dsc);
  return dsc;
}

export { getDynamicSamplingContextFromClient };